const stringToColor = (string: string): string => {
  let hash = 0;

  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }

  const shortened = hash % 360;
  return "hsl(" + shortened + ",100%,30%)";
};

export default stringToColor;
